import { BrowserModule } from "@angular/platform-browser";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { HttpModule } from "@angular/http";

import { AppComponent } from "./app.component";

import { MatDialogModule, MatFormFieldModule } from "@angular/material";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";

import { ROUTES } from "./app.routing";
import { AuthGuard } from "./guards/auth.guard";
import { HttpUtilService } from "./services/http-util-service";
import { MDBBootstrapModule } from "angular-bootstrap-md";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { LoginService } from "./services/login-service";
import { DisciplinaService } from "./services/disciplina-service";
import { AlunoService } from "./services/aluno-service";
import { ProvaService } from "./services/prova-service";
import { DropZoneDirective } from "./drop-zone.directive";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { AngularFireModule } from "angularfire2";
import { AngularFireAuth } from "angularfire2/auth";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { NavbarAdminComponent } from "./navbar-admin/navbar-admin.component";
import { DisciplinaComponent } from "./dashboard/disciplina/disciplina.component";
import { AlunoComponent } from "./dashboard/aluno/aluno.component";
import { ProvaComponent } from "./dashboard/prova/prova.component";
import { ListaAlunoComponent } from "./dashboard/aluno/lista-aluno/lista-aluno.component";
import { ListaDisciplinaComponent } from "./dashboard/disciplina/lista-disciplina/lista-disciplina.component";
import { ListaProvaComponent } from "./dashboard/prova/lista-prova/lista-prova.component";

import { AngularFireDatabase } from "angularfire2/database";
import { MatRadioModule } from "@angular/material/radio";
import {
  MatInputModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSortModule,
  MatTableModule,
} from "@angular/material";
import { VisualizarProvaComponent } from "./dashboard/prova/visualizar-prova/visualizar-prova.component";
import { RouterModule, PreloadAllModules } from "@angular/router";
import { CursoService } from "./services/curso-service";
import { AcessoComponent } from "./acesso/acesso.component";
import { ContratoComponent } from "./contrato/contrato.component";
import { AngularFireStorageModule } from "angularfire2/storage";
import { NgxMaskModule, IConfig } from "ngx-mask";

import { DeclaracaoComponent } from "./declaracao/declaracao.component";
import { DeclaracaoViewComponent } from "./declaracao/declaracao-view/declaracao-view.component";
import { DeclaracaoDetailsComponent } from "./declaracao/declaracao-view/declaracao-details/declaracao-details.component";
import { DeclaracaoFinalComponent } from "./declaracao/declaracao-view/declaracao-details/declaracao-final/declaracao-final.component";
import { DeclaracaoCqtComponent } from "./declaracao-cqt/declaracao-cqt.component";
import { DeclaracaoViewCqtComponent } from "./declaracao-cqt/declaracao-view/declaracao-view-cqt.component";
import { DeclaracaoDetailsCqtComponent } from "./declaracao-cqt/declaracao-view/declaracao-details/declaracao-details-cqt.component";
import { DeclaracaoFinalCqtComponent } from "./declaracao-cqt/declaracao-view/declaracao-details/declaracao-final/declaracao-final-cqt.component";

import { OcorrenciaComponent } from "./acesso/ocorrencia/ocorrencia.component";
import { CadastrarPaisagemComponent } from "./cadastrar-paisagem/cadastrar-paisagem.component";

import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { CadastrarAnimalComponent } from "./cadastrar-animal/cadastrar-animal.component";
import { ControleSeapComponent } from "./controle-seap/controle-seap.component";
import { AddCursoComponent } from "./controle-seap/add-curso/add-curso.component";
import { ControleSeapService } from "./controle-seap/controle-seap.service";
import { ListaCursosComponent } from "./controle-seap/lista-cursos/lista-cursos.component";
import { ListaMatriculasComponent } from "./controle-seap/lista-matriculas/lista-matriculas.component";
import { AddMatriculaComponent } from "./controle-seap/add-matricula/add-matricula.component";
import { ListaMatriculasConcluidasComponent } from "./controle-seap/lista-matriculas-concluidas/lista-matriculas-concluidas.component";

export let options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export const firebaseConfig = {
  apiKey: "AIzaSyAjLebPdpbfqbY3g8sKvvtw6O4FEsttcbs",
  authDomain: "pecteresopolis.firebaseapp.com",
  databaseURL: "https://pecteresopolis.firebaseio.com",
  projectId: "pecteresopolis",
  storageBucket: "pecteresopolis.appspot.com",
  messagingSenderId: "512559835003",
  appId: "1:512559835003:web:ac06331ccc02f014697fde"
};


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AcessoComponent,
    LoginComponent,
    DashboardComponent,
    NavbarAdminComponent,
    DisciplinaComponent,
    AlunoComponent,
    ProvaComponent,
    ListaAlunoComponent,
    ListaDisciplinaComponent,
    ListaProvaComponent,
    VisualizarProvaComponent,
    ContratoComponent,
    DeclaracaoComponent,
    DeclaracaoCqtComponent,
    DropZoneDirective,
    FileUploadComponent,
    DeclaracaoViewComponent,
    DeclaracaoDetailsComponent,
    DeclaracaoFinalComponent,
    DeclaracaoViewCqtComponent,
    DeclaracaoDetailsCqtComponent,
    DeclaracaoFinalCqtComponent,
    OcorrenciaComponent,
    CadastrarPaisagemComponent,
    CadastrarAnimalComponent,
    ControleSeapComponent,
    AddCursoComponent,
    ListaCursosComponent,
    ListaMatriculasComponent,
    AddMatriculaComponent,
    ListaMatriculasConcluidasComponent,
  ],
  entryComponents: [
    DisciplinaComponent,
    AlunoComponent,
    ProvaComponent,
    ListaAlunoComponent,
    ListaDisciplinaComponent,
    ListaProvaComponent,
    VisualizarProvaComponent,
    FileUploadComponent,
    DeclaracaoDetailsComponent,
    DeclaracaoDetailsCqtComponent,
  ],
  imports: [
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    NgxMaskModule.forRoot(options),
    BrowserModule,
    BrowserAnimationsModule,
    MDBBootstrapModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
    }), // ToastrModule added
    HttpModule,
    RouterModule.forRoot(ROUTES, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatRadioModule,
    AngularFireStorageModule,
  ],
  providers: [
    AuthGuard,
    HttpUtilService,
    LoginService,
    AngularFireModule,
    AngularFireAuth,
    AngularFireDatabase,
    DisciplinaService,
    AlunoService,
    ProvaService,
    CursoService,
    ControleSeapService,
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
